
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_2rhyz_1acr2_5",
  "input": "awsui_input_2rhyz_1acr2_9",
  "input-readonly": "awsui_input-readonly_2rhyz_1acr2_29",
  "input-invalid": "awsui_input-invalid_2rhyz_1acr2_90",
  "input-has-icon-left": "awsui_input-has-icon-left_2rhyz_1acr2_101",
  "input-type-search": "awsui_input-type-search_2rhyz_1acr2_106",
  "input-has-icon-right": "awsui_input-has-icon-right_2rhyz_1acr2_122",
  "input-has-no-border-radius": "awsui_input-has-no-border-radius_2rhyz_1acr2_125",
  "input-container": "awsui_input-container_2rhyz_1acr2_129",
  "input-icon": "awsui_input-icon_2rhyz_1acr2_134",
  "input-icon-hoverable": "awsui_input-icon-hoverable_2rhyz_1acr2_137",
  "input-icon-left": "awsui_input-icon-left_2rhyz_1acr2_141",
  "input-icon-right": "awsui_input-icon-right_2rhyz_1acr2_146"
};
  